import { Autocomplete, Checkbox, TextField } from "@mui/material";

interface MultiChoiceEditProps {
  value: any[];
  onChange: (_val: any[]) => void;
  options: any[];
  error?: string;
}

const MultiChoiceEdit = ({ value = [], onChange, options, error }: MultiChoiceEditProps) => {
  const normalizedOptions = options.map((opt) => {
    if (opt.code) return { label: opt.name, value: opt.code, raw: opt };
    if (Array.isArray(opt)) return { label: opt[1], value: opt[0], raw: opt };
    return { label: opt, value: opt, raw: opt };
  });

  const isSelected = (option: any) => {
    const valToCompare = option.value;
    return value.some((v: any) => {
      const currentVal = v.code || (Array.isArray(v) ? v[0] : v);
      return currentVal === valToCompare;
    });
  };

  return (
    <Autocomplete
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      limitTags={2}
      onChange={(_e, selected) => onChange(selected.map((s) => s.raw))}
      options={normalizedOptions}
      renderInput={(params) => <TextField {...params} error={!!error} helperText={error} variant="standard" />}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            <Checkbox checked={selected} style={{ marginRight: 8 }} />
            {option.label}
          </li>
        );
      }}
      value={normalizedOptions.filter(isSelected)}
      disableCloseOnSelect
      multiple
    />
  );
};

export default MultiChoiceEdit;
